






import { defineComponent } from '@vue/composition-api';
import { bemx } from '@berlin-front/common/utils';

/**
 * ## 補足ノート
 *
 * モジュール内の補足メッセージを扱うコンポーネント。
 * Vuetifyの`v-alert`コンポーネントのラッパー。
 * slotをとってコンテンツを囲むだけのコンポーネント。
 * 見た目はVuetify標準のborder="left"のデザインをベースに、角の丸みや色をCSSで上書きしている。
 * タイトルあり表記（定義タグを利用）と、タイトルなしの通常文章表記の2種類を想定。定義タグのタイトルは太字。
 *
 * Vuetifyの`v-alert`については以下を参照。
 *
 * - 仕様書：https://vuetifyjs.com/ja/api/v-alert/
 * - コード：https://github.com/vuetifyjs/vuetify/tree/master/packages/vuetify/src/components/VAlert
 *
 */
export default defineComponent({
  name: 'AppSupplement',
  setup() {
    const className = bemx('AppSupplement');
    return {
      className,
    };
  },
});
